import { message } from "ant-design-vue";

export function useMessage() {

  const successMessage = (successMessage) => {
    message.success(successMessage);
  };

  const errorMessage = (errorMessage) => {
    message.error(errorMessage);
  };

  return { successMessage , errorMessage }

}